import { createUseStyles, useTheme } from 'react-jss'
import style from './style'
import {
  Container,
  Row,
  TypographyElement,
  AdCard,
  Col
} from 'UI'
import Text from './text.json'
import Layout from 'components/common/Layout'
import { CatalogLearningPathsPath, CatalogPath } from 'navigation/Routes'
import StatusCode from './Seo/StatusCode'
import { pageNotFoundImage } from 'assets'

const useStyles = createUseStyles(style)

export default ({ goToUrl }) => {
  const theme = useTheme()
  const { container, image } = useStyles()
  return (
    <Layout>
      <StatusCode />
      <Container className={container}>
        <Row>
          <Col grid={12}>
            <object className={image} data={pageNotFoundImage} type='image/svg+xml' />
          </Col>
        </Row>
        <Row>
          <Col grid={12}>
            <TypographyElement
              variant='heading1'
              spacing='32px 0 16px 0'
              spacingTablet='24px 0 16px 0'
              spacingMobile='24px 0 16px 0'
            >
              {Text.title}
            </TypographyElement>
          </Col>
        </Row>
        <Row>
          <Col grid={12}>
            <TypographyElement
              variant='body1'
              spacing='0 0 32px 0'
              spacingTablet='0 0 24px 0'
            >
              {Text.subTitle1}
            </TypographyElement>
          </Col>
        </Row>
        <Row gap={48} tabletDirection='column' mobileDirection='column' tabletGap={16} mobileGap={16}>
          <Col grid={6} mgrid={12} sgrid={12}>
            <AdCard
              title={Text.courseCard.title}
              core={Text.courseCard.paragraph}
              buttonLabel={Text.courseCard.button}
              onButtonClick={() => goToUrl(CatalogPath)}
              shadowColor={theme.primary[0]}
            />
          </Col>
          <Col grid={6} mgrid={12} sgrid={12}>
            <AdCard
              title={Text.learningPathCard.title}
              core={Text.learningPathCard.paragraph}
              buttonLabel={Text.learningPathCard.button}
              onButtonClick={() => goToUrl(CatalogLearningPathsPath)}
              shadowColor={theme.extra.violet}
            />
          </Col>
        </Row>
      </Container>
    </Layout>
  )
}
